"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomerHiddenData = void 0;
const react_query_1 = require("@tanstack/react-query");
const customerHiddenData_1 = require("../../services/customerHiddenData/index.js");
const types_1 = require("../../types/index.js");
/**
 * Hook adapter para obter dados mascarados do Cliente Final não autenticado.
 * @param customerId ID do Cliente Final
 * @returns {Object} Estado da requisição
 * @see {@link getCustomerHiddenData}
 * @example
 * const customerId = '123'
 * const {
 *   isLoading,
 *   isSuccess,
 *   isError,
 *   customerHiddenData,
 *   error,
 * } = useCustomerHiddenData(customerId)
 */
function useCustomerHiddenData(customerId, queryOptions) {
    const { isSuccess, isLoading, isError, data: customerHiddenData, error, } = (0, react_query_1.useQuery)([types_1.QueryKeys.GET_CUSTOMER_HIDDEN_DATA, customerId], ({ signal }) => __awaiter(this, void 0, void 0, function* () { return yield (0, customerHiddenData_1.getCustomerHiddenData)(customerId, signal); }), queryOptions);
    return { isSuccess, isLoading, isError, customerHiddenData, error };
}
exports.useCustomerHiddenData = useCustomerHiddenData;
